import { render, staticRenderFns } from "./AttemptIconDiff.vue?vue&type=template&id=15aeb7b9"
import script from "./AttemptIconDiff.vue?vue&type=script&lang=js"
export * from "./AttemptIconDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports